/**
 * TEMPORARY: AD toggles and AD metadata loading only for internal users.
 * To open to everyone: delete this file and remove its imports/usages (grep `canUseAudioDescribed`).
 */
export function canUseAudioDescribed(user) {
  return Boolean(user?.roles?.includes('internal'));
}
